import { Button } from '@/shared/components/shadcn/button';
import { Skeleton } from '@/shared/components/shadcn/skeleton';
import { AlertCircle } from 'lucide-react';

export function CampaignAnalysisLoadingState() {
  return (
    <div
      aria-label="Loading analysis history"
      className="grid min-h-105 gap-6 lg:grid-cols-[220px_minmax(0,1fr)] lg:items-start"
      role="status"
    >
      <aside className="flex flex-col gap-2" aria-hidden="true">
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton className="h-14.5 rounded-xl" key={index} />
        ))}
      </aside>
      <Skeleton className="min-h-72 rounded-lg" aria-hidden="true" />
    </div>
  );
}

export function CampaignAnalysisErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="grid min-h-105 gap-6 lg:grid-cols-[220px_minmax(0,1fr)] lg:items-stretch">
      <aside
        aria-label="Analysis history"
        className="border-border bg-card flex flex-col items-start rounded-lg border p-4"
      >
        <AlertCircle className="text-destructive size-5" aria-hidden="true" />
        <h3 className="text-foreground mt-3 text-sm font-semibold">History unavailable</h3>
        <p className="text-muted-foreground mt-2 text-sm leading-6" role="alert">
          Analysis history could not be loaded.
        </p>
        <Button className="mt-4" onClick={onRetry} size="sm" variant="outline">
          Retry
        </Button>
      </aside>
      <div className="border-border bg-card flex min-h-72 items-center justify-center rounded-lg border p-6 text-center">
        <div className="max-w-md">
          <h3 className="text-foreground text-base font-semibold">Campaign analysis</h3>
          <p className="text-muted-foreground mt-2 text-sm leading-6">
            Retry to load analysis runs and report details.
          </p>
        </div>
      </div>
    </div>
  );
}
